<template>
    <div
      class="bg"
      id="main_bg"
     
    >
      <img class="login_jcd" src="../assets/jcd_logo.png" alt="jcd_logo" />
      
    <activeAccount></activeAccount>
      <!--
      <div class="version">
        <a class="version_href">{{version}}</a>
      </div>
      -->
    </div>
  </template>
  
  <script>
  import { Message } from 'element-ui';
  import activeAccount from "./activeAccount-form.vue";
  import Verify from "./Verify.vue";
  import _global from "./global.vue";
  export default {
    data() {
      return {
       
      };
    },
    components: {
        activeAccount
    },
    metaInfo: {
      title: "BAM Login",
      author: "JCDecaux",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "德高测量巴士媒体受众数量系统 This is a system to mesure the audience of bus media for JCDecaux",
        },
        { vmid: "author", name: "author", content: "JCDecaux" },
        { charset: "utf-8" },
      ],
    },
  
    created() {
      
    },
    mounted() {
     
    },
  
    methods: {
      
      switchLang(event) {
        sessionStorage.setItem("lang", JSON.stringify(event));
      },
      openMessage() {
       
      }
    },
  
    destroyed() {
      
    }
  };
  </script>
  <style lang="scss" scoped>
    .version_href{
      cursor: pointer;
      user-select: none;
      font-size: 20px;
    }
    .version{
      position: fixed;
      height: 20px;
      width:100%;
      background-color: #CCCCCC;
      bottom: 0;
      display: flex;
      justify-content: center;
      color: grey;
    }
  </style>
  